export enum GtmContactType {
    PHONE = "telefon",
    FORM = "formularz",
    UNKNOWN = "na"
}
